import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useConfigurationContext } from 'xen/providers';
import { CLIENTS_PATHS, PROSPECTS_PATHS } from 'xen/routes';
import { NavBarLink } from '../nav-bar-link';
export const ClientNavBarBody = () => {
    const { tenant } = useConfigurationContext();
    const { factoring } = tenant;
    return (_jsxs(_Fragment, { children: [factoring.enabled && (_jsx(NavBarLink, { active: location.pathname.startsWith(CLIENTS_PATHS.root), icon: "UserDollar", label: "Factoring", to: "/factoring/client-dashboard" })), _jsx(NavBarLink, { active: location.pathname.startsWith(PROSPECTS_PATHS.root), icon: "ListCheck", label: "Applications", to: "/prospects/dashboard" })] }));
};
